define('shared/initializer/form/newHouseAdapters/util/getLeadETag',[
    '$',
    'shared/lib/RSVP',
    'shared/util/state', 
    'shared/util/dispatchers/DataDispatcher'
], function (
    $,
    RSVP,
    state,
    DataDispatcher
) {
    return function () {
        var etag;
        var dispatcher = new DataDispatcher($(document.documentElement));

        return dispatcher
            .dispatch({
                items: {
                    'etag': {
                        sources: [
                            {
                                retrieve:function(){
                                    return state.get('form.etag').then(function(values){
                                        var formEtag = values && values[0];
                                        if(formEtag){
                                            if(!formEtag.endsWith('_1')){
                                                formEtag += '_1';
                                            }
                                        }

                                        return RSVP.resolve(formEtag);
                                    });
                                }
                            },
                            {type: 'state', key: 'page.etag', allowUndefined: true},
                            {type: 'state', key: 'session.etag', allowUndefined: true}
                        ],
                        targets: [{publish: function (key, value){
                            etag = value;
                            return RSVP.resolve();
                        }}],
                        allowUndefined: true
                    }
                },
                timeout: 1000 * 60 * 60
            })
            .then(function(){
                return etag;
            });
    };
});
